import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -64, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden pb-[0.08em] ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "115%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Reveal = ({ children, delay = 0, y = 44, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <p className={`text-xs font-semibold uppercase tracking-[0.32em] text-[#C5A059] ${className}`}>
    {children}
  </p>
);

export const SectionHeading = ({ overline, title, copy, className = "" }) => (
  <div className={className}>
    <Reveal>
      <Overline>{overline}</Overline>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-5 max-w-2xl text-2xl font-light leading-[1.15] tracking-tight text-[#F9F8F6] sm:text-3xl lg:text-4xl">
        {title}
      </h2>
    </Reveal>
    {copy ? (
      <Reveal delay={0.16}>
        <p className="mt-5 max-w-xl text-base font-light leading-relaxed text-[#A1A1AA]">{copy}</p>
      </Reveal>
    ) : null}
  </div>
);
